export default "__VITE_ASSET__CPZNRI24__"